import api from "./api";
import { getArgs } from "../utils";

const route = "/analytics";

const AnaliticasService = {
  getLeaderboard: (filters) =>
    api.get(`${route}/leaderboard?${getArgs(filters)}`),
  getOnlineLeaderboard: (filters) =>
    api.get(`${route}/leaderboard/online?${getArgs(filters)}`),
};

export default AnaliticasService;
